<!-- 裂变活动 -->
<template>
  <div>
    <div class="head-title">裂变工具</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            在【裂变工具】功能中，可以实现多样化活动进行裂变、设置不同奖品吸引流量、配备专属客服跟进服务、为多个企业成员企业微信同时引流等场景。<a
              class="help-link"
              href="http://www.weijub.com/index/index/news_detail?id=151"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mainC">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建活动</el-button
          >
          <el-button
            style="margin-left: 2.0rem"
            
            icon="el-icon-delete"
            @click="onDels"
            >批量删除</el-button
          >
        </div>
        <div class="nav-r">
          <el-input
            clearable
            style="width: 35.0rem; "
            placeholder="请输入活动名称"
            prefix-icon="el-icon-search"
            v-model="q"
            @change="getList()"
          ><el-button slot="append" type="primary" @click="getList()"
            >查询</el-button
          >
          </el-input>
          
        </div>
      </nav>
      <div class="container">
        <el-table
          :data="tableData"
          v-loading="tableLoading"
          border
          @selection-change="onSelection"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="code_url" label="二维码" >
            <template slot-scope="scope">
              <el-image
                style="width: 7.2rem; height: 7.2rem"
                :src="scope.row.code_url"
                :preview-src-list="[scope.row.code_url]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="activity_name"
            label="活动名称"
          
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="活动规则" >
            <template slot-scope="scope">
              <div v-if="scope.row.fission_type == 1">
                <p>奖品：{{ scope.row.prize_name }}</p>
                <p>({{ scope.row.complete_percent }})</p>
                <p>
                  <el-tag size="mini" type="warning"
                    >需邀请{{ scope.row.people_number }}位好友助力</el-tag
                  >
                </p>
              </div>
              <div v-else-if="scope.row.fission_type == 2">
                <p>奖品：{{ scope.row.money_total }}元</p>
                <p>({{ scope.row.complete_percent }})</p>
                <p>
                  <el-tag size="mini" type="warning"
                    >需邀请{{ scope.row.people_number }}位好友助力</el-tag
                  >
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="活动时间" >
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.start_time }}至</p>
                <p>{{ scope.row.end_time }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="user_id_name" label="引流成员" >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                style="margin: .2rem"
                v-for="t in scope.row.user_id_name"
                :key="t"
                >{{ t }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="status_name" label="状态" >
            <template slot-scope="scope">
              <el-tag size="mini" v-if="scope.row.status===2" type="success"  style="margin: .2rem">进行中</el-tag>
              <el-tag size="mini" v-else-if="scope.row.status===1" type="warning"  style="margin: .2rem">未开始</el-tag>
              <el-tag size="mini" v-else-if="scope.row.status===3" type="danger"  style="margin: .2rem">已结束</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="support_user_id_name"
            label="联系客服"
            
          >
            <template slot-scope="scope">
              <span size="mini" style="margin: .2rem">{{
                scope.row.support_user_id_name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" >
          </el-table-column>
          <el-table-column  fixed="right"  width="300" label="操作">
            <template slot-scope="scope">
              <el-button
              type="text"
              
                @click="onRead(scope.row)"
                
              >
                查看
              </el-button>
              <el-button
              type="text"
              
                @click="onAssistant(scope.row)"
                
              >
                参与者
              </el-button>
              <el-button
              type="text"
              
                @click="onShare(scope.row)"
                
              >
                分享
              </el-button>
              <el-button
              type="text"
                @click="onDisable(scope.row)"
                
              >
                使失效
              </el-button>
              <el-button
              type="text"
                style="color: #F00000 !important;"
                @click="onDel(scope.row)"
                
              >
                删除
              </el-button>
              
              

              
              
              
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            :auto-scroll="false"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
    <el-dialog
    center
      :title="currentRow.activity_name"
      width="35%"
      :visible.sync="dialogVisibleShare"
    >
      <div class="share-box">
        <div class="share-box-left">
          <div class="share-box-left-l">方法一：</div>
          <div class="share-box-left-r">
            <div class="share-box-left-r-t">
              <el-image
                style="width: 10.0rem; height: 10.0rem"
                :preview-src-list="[currentRow.code_url]"
                :src="currentRow.code_url"
              ></el-image>
            </div>
            <div class="share-box-left-r-b">
              <el-button size="mini" type="primary">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${currentRow.code_url}&usertoken=${tooken.usertoken}`"
                  style="color: #fff"
                  :download="`${currentRow.activity_name}二维码`"
                  >下载二维码</a
                ></el-button
              >
            </div>
          </div>
        </div>
        <div class="share-box-right">
          <div class="share-box-left-l">方法二：</div>
          <div class="share-box-left-r">
            <div class="share-box-left-r-t">
              <span>
                {{
                  `https://work.weijub.com/h5/#/pages/activity/fission?id=${currentRow.id}&account_id=${currentRow.account_id}`
                }}
              </span>
            </div>
            <div class="share-box-left-r-b">
              <el-button
                class="btn"
                style="color: #fff"
                size="mini"
                type="primary"
                :data-clipboard-text="`https://work.weijub.com/h5/#/pages/activity/fission?id=${currentRow.id}&account_id=${currentRow.account_id}`"
                >复制链接</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="share-footer">
        <el-button size="small" @click="dialogVisibleShare = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ClipboardJS from "clipboard";
let clipboard;
import mailList from "@/components/MailList";
export default {
  name: "fissionTools",
  components: {
    mailList,
  },
  data() {
    return {
      q: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      currentRow: {},
      dialogVisibleShare: false,
      code: "",
      info: {},
      tableLoading: true,
    };
  },

  components: {},

  computed: {},

  async mounted() {
    this.getIfAccountPublicSet();
    await this.getList();
    this.initCopy(".btn");
  },
  destroyed() {
    clipboard.destroy();
  },
  methods: {
    async getIfAccountPublicSet() {
      const { data: res } = await this.axios({
        url: "/crm/AcountPublic/ifAccountPublicSet",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
        }),
      });
      this.code = res.code.toString();
      if (res.code == 1) {
        this.info = res.data;
      }
    },
    initCopy(selector = ".btn") {
      clipboard = new ClipboardJS(selector);
      clipboard.on("success", (e) => {
        if (e.text == 0) {
          this.$message.error("复制失败，请稍后再试");
        } else {
          this.$message.success("复制成功");
        }
        e.clearSelection();
      });

      clipboard.on("error", () => {
        this.$message.error("复制失败，请稍后再试");
      });
    },
    onAdd() {
      if (process.env.NODE_ENV === "development") {
        this.$router.push({
          name: "fissionToolsAdd",
        });
      }
      // if (this.code == 0) {
      //   this.$message.warning("请先绑定公众号");
      //   return;
      // }
      // if (this.info.verify_type_info.id == -1) {
      //   this.$message.warning("公众号认证后才可新建活动");
      //   return;
      // }
      this.$router.push({
        name: "fissionToolsAdd",
      });
    },
    onSelection(val) {
      this.multipleSelection = val;
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "crm/ActivityFission/getList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          activity_name: this.q,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
        }),
      });
      this.tableLoading = false;
      if (res.code == 1) {
        this.tableData = res.data.data;
        // console.log(this.tableData);
        this.total = res.count;
      }
    },
    onDisable(row) {
      this.$confirm(`确定结束${row.activity_name}活动吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.editEndTime(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    async editEndTime(id) {
      try {
        const { data: res } = await this.axios({
          url: "/crm/ActivityFission/editEndTime",
          method: "POST",
          data: this.qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id,
          }),
        });
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.getList();
        } else if (res.code == 0) {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onRead(row) {
      this.$router.push({
        name: "fissionToolsDetail",
        query: {
          id: row.id,
        },
      });
    },
    onShare(row) {
      this.currentRow = row;
      this.dialogVisibleShare = true;
    },
    onAssistant(row) {
      this.$router.push({
        name: "fissionAssistant",
        query: {
          id: row.id,
        },
      });
    },
    onDels() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除该活动, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const ids = this.multipleSelection.map((i) => i.id);
            this.del(String(ids));
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        this.$message("请选择您要删除的活动");
      }
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async del(ids) {
      const { data: res } = await this.axios({
        url: "/crm/ActivityFission/delActivityFission",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          ids,
        }),
      });
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.getList();
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin-top: 1.6rem;
  overflow-x: scroll;
}
.mainC {
  padding: 3.0rem 3.0rem 0;
  border-radius: 1.0rem;
  box-shadow: .0rem .2rem 4.0rem .0rem #eeeeee;
  background: #FDFEFE;
}

.el-table .el-button{
  font-size: 1.6rem;
    border: .0rem;
    padding: 1.0rem .0rem 1.0rem .0rem !important;
    background: none;
    margin: .0rem !important;
    text-align: left;
    width: 9.0rem;
}
.el-tag--mini {
    height: 2.5rem;
    padding: .4rem .7rem;
    
    
    border-radius: .2rem;
    
    font-size: 1.2rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    
    line-height: 1.7rem;
}
.el-tag.el-tag--warning{
  
    color: #FF793F;
    background: #FFF4ED;
border-radius: .2rem;
border: .1rem solid #FFE6DA;
}
.container{
  background: #FDFEFE !important;
}
.share-box {
  display: flex;
  justify-content: space-between;
  color: rgba(0, 0, 0, 0.65);
  .share-box-left,
  .share-box-right {
    display: flex;
    flex: 1;
    &-l {
      padding-right: 2.0rem;
      min-width: 9.0rem;
    }
    &-r {
      &-t {
        padding-bottom: 2.0rem;
      }
    }
  }
}


</style>